export default "__VITE_ASSET__99b8f6db__"